export const PERSISTED_QUERY_PARAMS = [
  'q[price][]',
  'q[region_id]',
  'order',
  'keywords_source',
  'user_id',
];
